import i18n from "i18next";
import api from "service/axios.service";
import { biomesBrasil } from "./types";

export const getDataTerritoryCategory = async () => async (dispatch) => {
  dispatch({ type: biomesBrasil.BIOMES_BRASIL_REQUEST });
  try {
    const res = await api.get(`/v1/biomes`);

    const { data } = res || {};

    dispatch({
      type: biomesBrasil.BIOMES_BRASIL_REQUEST_SUCCESS,
      payload: data,
    });
    return data;
  } catch (error) {
    const { response } = error || {};
    const { data } = response || {};
    const { message } = data || {};

    const msg = message || i18n.t("unknownError");

    dispatch({
      type: biomesBrasil.BIOMES_BRASIL_REQUEST_FAIL,
      payload: msg,
    });
  }
};
